<template>
  <div class="word-list13">
    <div
      class="head"
      :style="{
        backgroundImage: 'url(' + dataInfo.cover + ')'
      }"
    >
      {{ dataInfo.name }}
    </div>
    <div class="g-box">
      <div class="content">
        <div class="main">
          <div
            class="item"
            @click="toDetail(item)"
            v-for="item in list"
            :key="item.id"
            :style="{
              backgroundImage: 'url(' + item.image + ')'
            }"
          >
            <div class="top">
              <!-- <div class="title">{{ item.title }}</div> -->
              <!-- <div class="btn" @click="toDetail(item)">查看详情 ></div> -->
            </div>
          </div>
        </div>
        <el-pagination
          v-if="total > 8"
          @current-change="onCurrentChange"
          background
          layout="prev, pager, next"
          :current-page="pageNum"
          :page-size="pageSize"
          :total="total"
          class="m-pagination"
        />
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";

export default {
  data() {
    return {
      query: this.$route.query,
      params: {},
      dataInfo: {},
      pageSize: 8,
      dataList: []
    };
  },
  mixins: [pageMain_mx],
  components: {},
  mounted() {},
  methods: {
    async init() {
      this.params = this.$route.params;
      this.pageNum = 1;
      this.getAjax();
      const dataInfo = await this.getMenuInfo(this.params.menuId);
      this.dataInfo = dataInfo;
    },
    getAjax() {
      this.getList();
    },
    toDetail(item) {
      this.$router.push("/article_details/" + item.id);
      console.log(item, "itemmm");
    }
  }
};
</script>
<style lang="less">
.word-list13 {
  .head {
    height: 280px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 60px;
    color: #fff;
    letter-spacing: 40px;
  }
  .content {
    padding-top: 60px;
    padding-bottom: 120px;
    .main {
      display: flex;
      flex-wrap: wrap;
      .item {
        padding: 90px 60px 0;
        margin-bottom: 40px;
        margin-right: 40px;
        width: 580px;
        height: 320px;
        box-sizing: border-box;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        .top {
          .title {
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #000000;
            width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .btn {
            margin-top: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 104px;
            height: 32px;
            border-radius: 2px;
            cursor: pointer;
            border: 1px solid #000;
          }
        }
      }
      .item:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
}
</style>
